module.exports = __webpack_public_path__ + "media/images/stars/0-1e5ae3da503b29a7cd53267dbdfaca2d.gif";